<script lang="ts">
  import type { SvelteComponent } from "svelte"
  import type { User } from "firebase/auth"
  import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth"

  import { init as initFirebase, getMaintStatus } from "./utils/firebase"

  import "./reset.css"
  import UnityApplication from "./components/unity-application.svelte"
  import { LoginView, SignInAnonymously, SignInWithCode, UserAuthContainer } from "./components/auth"
  import { signInClaims, signInWithoutAnonymously } from "./components/auth/actions"
  import { getLineAuth } from "./utils/line"

  let userAuthOption: { [key: string]: any } = {}
  let loginComponent: typeof SvelteComponent
  let loginComponentParams: { [key: string]: any } = {}
  let appComponent: typeof SvelteComponent = UnityApplication

  let promise = init()
  let maintStatus: string | null = null

  async function init() {
    // Firebase を初期化
    await initFirebase()

    // ログイン管理
    const auth = getAuth()
    auth.languageCode = "ja"
    setPersistence(auth, browserLocalPersistence)
    maintStatus = await getMaintStatus()

    //Line認証
    const lineAuth = await getLineAuth()

    if (!import.meta.env.VITE_LIMIT_ACCESS || lineAuth) {
      const searchParams = new URLSearchParams(location.search)
      if (searchParams.has("code") && !searchParams.has("state")) {
        // 認証コードでログイン
        loginComponent = SignInWithCode
        loginComponentParams = { code: searchParams.get("code") }
        userAuthOption = { action: signInWithoutAnonymously, allowMultipleLogin: false }
      } else if (searchParams.has("login")) {
        // ログイン認証あり
        loginComponent = LoginView
        loginComponentParams = { method: searchParams.get("login") }
        userAuthOption = { action: signInWithoutAnonymously, allowMultipleLogin: false }
      } else {
        // 匿名認証でログイン
        loginComponent = SignInAnonymously
      }
    } else {
      loginComponent = LoginView
      loginComponentParams = { title: "ブルボンメタバース" }
      userAuthOption = { action: signInClaims, param: hasStagingClaims }
    }

    // TODO:消す
    /*
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has("lineTest")) {
      appComponent = (await import("./components/lineTest.svelte")).default
    }
    */
  }

  async function hasStagingClaims(user: User): Promise<boolean> {
    const idTokenResult = await user.getIdTokenResult()
    if (!!idTokenResult.claims.staging) {
      return true
    }
    return false
  }
</script>

{#await promise then}
  {#if typeof maintStatus === "string"}
    <p>
      {@html maintStatus}
    </p>
  {:else}
    <UserAuthContainer {...userAuthOption}>
      <svelte:component this={loginComponent} slot="login" {...loginComponentParams} />
      <svelte:component this={appComponent} slot="app" />
    </UserAuthContainer>
  {/if}
{:catch error}
  <p style="color: red">{error.message}</p>
{/await}

<style>
  :global(body) {
    transition: background-color 0.5s ease-out;
    -webkit-text-size-adjust: 100%;
  }

  @media (max-width: 767.98px) {
    :global(html) {
      font-size: 12px;
    }
  }

  p {
    padding: 1em;
  }
</style>
